"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartLabels(_ref) {
  var labels = _ref.labels;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chart-axis-labels"
  }, labels.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chart-label"
    }, /*#__PURE__*/_react.default.createElement("div", null, item));
  }));
}

ChartLabels.propTypes = {
  labels: _propTypes.default.arrayOf(_propTypes.default.oneOfType(_propTypes.default.string, _propTypes.default.node))
};
ChartLabels.defaultProps = {
  labels: []
};
var _default = ChartLabels;
exports.default = _default;